import { useEffect, useState } from 'react';
import { Search, Check, X } from 'lucide-react';
import { api } from '../lib/api';

export function MemberPicker({value,onChange}:{value:string;onChange(value:string):void}) {
  const [query,setQuery]=useState('');
  const [items,setItems]=useState<any[]>([]);
  const [selected,setSelected]=useState<any>(null);
  const [loading,setLoading]=useState(false);
  const [error,setError]=useState('');
  useEffect(()=>{
    let cancelled=false;
    setLoading(true);setError('');
    const timer=window.setTimeout(async()=>{
      try {const result=await api.members(new URLSearchParams({search:query,source:'real',limit:'25'}));if(!cancelled)setItems(result.items);}
      catch(e){if(!cancelled)setError(e instanceof Error?e.message:'無法載入會員');}
      finally{if(!cancelled)setLoading(false);}
    },200);
    return()=>{cancelled=true;window.clearTimeout(timer);};
  },[query]);
  return <div className="member-picker"><strong>選擇收件會員</strong>
    {value ? <div className="selected-recipient"><Check size={17}/><span>{selected?.first_name || value}{selected?.username && <small>@{selected.username}</small>}</span><button type="button" className="icon-button" aria-label="重新選擇收件會員" onClick={()=>{onChange('');setSelected(null);}}><X size={17}/></button></div> : <>
      <label className="admin-search"><Search size={17}/><input aria-label="搜尋收件會員" placeholder="搜尋姓名或 @帳號" value={query} onChange={e=>setQuery(e.target.value)}/></label>
      <div className="recipient-options" aria-label="收件會員清單">{loading?<p role="status">搜尋中…</p>:error?<p role="alert">{error}</p>:items.length?items.map(item=><button type="button" key={item.id} disabled={!item.bot_started_at} onClick={()=>{setSelected(item);onChange(item.telegram_id);}}><span>{item.last_name}{item.first_name}<small>{item.username?`@${item.username}`:'未設定帳號名稱'}</small></span><small>{item.bot_started_at?'選擇':'尚未啟動 Bot'}</small></button>):<p>找不到會員，試試其他姓名。</p>}</div>
    </>}
  </div>;
}
